var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"section docScroll mt-6",attrs:{"id":"recurring_card_update"}},[_c('SectionColumn',{attrs:{"type":"left","title":"Update card details","content":_vm.contentLeftCol}}),_c('SectionColumn',{attrs:{"type":"right","content":_vm.contentRightCol}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }